<template>
  <div>
    <vx-card>
      <collapse-list :items="newsList">
        <template #header="{ item }">
          <div class="flex items-center">
            <span class="mr-5 block text-sm">{{ item.releaseDate }}</span>
            <div>{{ item.title }}</div>
          </div>
        </template>
        <template #content="{ item }">
          <div
            class="whitespace-pre-line break-words"
            v-html="formatText(item.text)"
          />
        </template>
      </collapse-list>
      <vs-pagination
        v-model="currentPage"
        :total="totalPage"
      />
    </vx-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CollapseList from '@/components/CollapseList'
import { replaceUrlStringWithATag, debounce } from '@/utils'

export default {
  name: 'News',
  components: {
    CollapseList
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 10
    }
  },
  computed: {
    ...mapState('news', ['newsList']),
    totalPage () {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  watch: {
    currentPage: {
      handler () {
        this.fetchData()
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    ...mapActions('news', ['listNews']),
    fetchData: debounce(async function () {
      try {
        const payload = {
          page: this.currentPage,
          per_page: this.pageSize
        }
        const res = await this.listNews(payload)
        this.total = res.data.total
      } catch (e) {
        console.log(e)
      }
    }, 500),
    formatText (value) {
      return replaceUrlStringWithATag(value)
    }
  }
}

</script>

<style>
</style>
